/**
 * File转base64
 * @param file 
 * @return base64
 * */
export function getBase64(file) {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		let fileResult = "";
		reader.readAsDataURL(file);
		//开始转
		reader.onload = () => {
			fileResult = reader.result;
		};
		//转失败
		reader.onerror = (error) => {
			reject(error);
		};
		//结束 resolve
		reader.onloadend = () => {
			resolve(fileResult);
		};
	});
}

export let userMedia = function(constraints, success, error) {
	if (navigator.mediaDevices.getUserMedia) {
		userMedia = function(constraints, success, error) {
			navigator.mediaDevices.getUserMedia(constraints).then(success).catch(error)
		}
	} else if (navigator.webkitGetUserMedia) {
		userMedia = function(constraints, success, error) {
			navigator.webkitGetUserMedia(constraints, success, error)
		}
	} else if (navigator.mozGetUserMedia) {
		userMedia = function(constraints, success, error) {
			navigator.mozGetUserMedia(constraints, success, error)
		}
	} else if (navigator.getUserMedia) {
		userMedia = function(constraints, success, error) {
			navigator.getUserMedia(constraints, success, error)
		}
	}

	userMedia(constraints, success, error)
}


// 开发地址与生产地址

export function setbaseurl(prod) {
	// let beseuels =  localStorage.getItem("beseurls")
	//return 'http://192.168.110.66:8054/api'
	// return 'http://101.34.17.168:8091/api'
	// return "http://124.70.87.191:8091/api"
	// return beseuels +"api"
	// return "http://124.70.87.191:8096/api"
	// return "http://127.0.0.1:8091/api"
	return window.myURL.URL
}


// 图片url装换
export function convertImgToDataURLviaCanvas(url, callback, outputFormat) {
	var img = new Image();
	img.crossOrigin = 'Anonymous';
	img.onload = function() {
		var canvas = document.createElement('CANVAS');
		var ctx = canvas.getContext('2d');
		var dataURL;
		canvas.height = this.height;
		canvas.width = this.width;
		ctx.drawImage(this, 0, 0);
		dataURL = canvas.toDataURL(outputFormat);
		callback(dataURL);
		canvas = null;
	};
	img.src = url;
}

export function convertFileToDataURLviaFileReader(url, callback) {
	var xhr = new XMLHttpRequest();
	xhr.responseType = 'blob';
	xhr.onload = function() {
		var reader = new FileReader();
		reader.onloadend = function() {
			callback(reader.result);
		}
		reader.readAsDataURL(xhr.response);
	};
	xhr.open('GET', url);
	xhr.send();
}

export function dataURLtoBlob(dataurl) {
	var arr = dataurl.split(','),
		mime = arr[0].match(/:(.*?);/)[1],
		bstr = atob(arr[1]),
		n = bstr.length,
		u8arr = new Uint8Array(n);
	while (n--) {
		u8arr[n] = bstr.charCodeAt(n);
	}
	return new Blob([u8arr], {
		type: mime
	});
}

/* 
 @防抖与节流
  @同一时间请求多次与一段时间只能请求一次
 */

// 防抖
export function _debounce(fn, delay) {

	var delay = delay || 200;
	var timer;
	return function() {
		var th = this;
		var args = arguments;
		if (timer) {
			clearTimeout(timer);
		}
		timer = setTimeout(function() {
			timer = null;
			fn.apply(th, args);
		}, delay);
	};
}
// 节流
export function _throttle(fn, interval) {
	var last;
	var timer;
	var interval = interval || 200;
	return function() {
		var th = this;
		var args = arguments;
		var now = +new Date();
		if (last && now - last < interval) {
			clearTimeout(timer);
			timer = setTimeout(function() {
				last = now;
				fn.apply(th, args);
			}, interval);
		} else {
			last = now;
			fn.apply(th, args);
		}
	}
}


//  阿拉伯数字转换为中文大写
export function arabicToChinese(num) {
	const chnNumChar = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
	const chnUnitChar = ["", "十", "百", "千", "万", "亿", "万亿", "亿亿"];
	let strIns = '',
		chnStr = '';
	let unitPos = 0;
	let zero = true;
	while (num > 0) {
		let v = num % 10;
		if (v === 0) {
			if (!zero) {
				zero = true;
				chnStr = chnNumChar[v] + chnStr;
			}
		} else {
			zero = false;
			strIns = chnNumChar[v];
			strIns += chnUnitChar[unitPos];
			chnStr = strIns + chnStr;
		}
		unitPos++;
		num = Math.floor(num / 10);
	}
	return chnStr;
}


// 判断是否移动端



export function ishfelve() {

	let flag = navigator.userAgent.match(
		/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
	)
	if (flag) {
		return true
	} else {
		return false
	}

}

// 去重
export function uniqueFunc(arr, uniId) {
	const res = new Map();
	return arr.filter((item) => !res.has(item[uniId]) && res.set(item[uniId], 1));
}

//  new date转换

export function changetimers(datetimer) {
	let dateObject = datetimer;
	let year = dateObject.getFullYear();
	let month = ("0" + (dateObject.getMonth() + 1)).slice(-2);
	let day = ("0" + dateObject.getDate()).slice(-2);
	let hours = ("0" + dateObject.getHours()).slice(-2);
	let minutes = ("0" + dateObject.getMinutes()).slice(-2);
	let seconds = ("0" + dateObject.getSeconds()).slice(-2);
	let formattedDate = year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;

	return formattedDate
}

// 传递日期对应星期
export function getWeekDay(date) {
	var weekDays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
	var dayIndex = new Date(date).getDay();
	return weekDays[dayIndex];
}

export function splitArray(arr, num) {
	var result = [];
	for (var i = 0; i < arr.length; i += num) {
		result.push(arr.slice(i, i + num));
	}
	return result;
}


// 时间转换  分钟转换多少时多少分
export function convertMinutesToHoursAndMinutes(minutes) {
	if (minutes === 0) {
		return {
			hours: 0,
			minutes: 0
		};
	}

	const hours = Math.floor(minutes / 60);
	const remainingMinutes = minutes % 60;

	return {
		hours: hours,
		minutes: remainingMinutes
	};
}


// Fri Aug 18 2023 00:00:00 GMT+0800 (香港标准时间) 转换

export function changedateString(data) {

	let datetime = new Date(data);
	let year = datetime.getFullYear();
	let month = datetime.getMonth();
	let date = datetime.getDate();
	let hour = datetime.getHours();
	let minute = datetime.getMinutes();
	let second = datetime.getSeconds();

	let result1 = year +
		'-' +
		((month + 1) >= 10 ? (month + 1) : '0' + (month + 1)) +
		'-' +
		((date + 1) < 10 ? '0' + date : date) +
		' ' +
		((hour + 1) < 10 ? '0' + hour : hour) +
		':' +
		((minute + 1) < 10 ? '0' + minute : minute) +
		':' +
		((second + 1) < 10 ? '0' + second : second);

	let result2 = year +
		'-' +
		((month + 1) >= 10 ? (month + 1) : '0' + (month + 1)) +
		'-' +
		((date + 1) < 10 ? '0' + date : date);

	let result = {
		hasTime: result1,
		withoutTime: result2
	};

	return result;


}


export function countdown(distance) {
	// 每秒更新页面上的倒计时  
	let intervalId = setInterval(function() {
		let now = new Date().getTime();
		let t = distance - (now - now % 1000);
		distance = Math.max(t - now, 0);
		let minutes = Math.floor((t / 1000 / 60) % 60);
		let seconds = Math.floor((t / 1000) % 60);
		return minutes + "分钟" + seconds + "秒"
		// console.log(minutes + "分钟" + seconds + "秒"); // 在控制台打印倒计时  
	}, 1000);

	// 一旦倒计时结束，清除定时器并做一些清理工作  
	setTimeout(function() {
		clearInterval(intervalId);
		console.log("倒计时结束");
	}, distance);
}